import { BOARD_CELLS, BOARD_SIZE, cellIndex, inBounds } from './board';
import { DIRECTIONS } from './win';

/** 勝利ラインの長さ（5 目） */
export const WIN_LENGTH = 5;

/**
 * 盤面上の「長さ 5 の一直線」すべて（13 方向 × 各方向の全始点で 4824 本）。
 * 各ラインは先頭マスから 5 つのマス索引（index = x + y*10 + z*100）の組。
 *
 * CPU のライン評価に使いまわすため、モジュールロード時に一度だけ前計算する。
 * 方向の定義は win.ts の DIRECTIONS を単一ソースとして再利用する。
 */
export const LINES: readonly (readonly number[])[] = buildLines();

/** マス索引 → そのマスを含むラインのインデックス一覧（候補マスの高速評価用） */
const LINES_BY_CELL: readonly (readonly number[])[] = buildLinesByCell();

function buildLines(): (readonly number[])[] {
  const lines: (readonly number[])[] = [];
  for (const [dx, dy, dz] of DIRECTIONS) {
    for (let z = 0; z < BOARD_SIZE; z++) {
      for (let y = 0; y < BOARD_SIZE; y++) {
        for (let x = 0; x < BOARD_SIZE; x++) {
          // 始点から 5 つ目が盤面内に収まる場合のみラインとして採用
          const ex = x + (WIN_LENGTH - 1) * dx;
          const ey = y + (WIN_LENGTH - 1) * dy;
          const ez = z + (WIN_LENGTH - 1) * dz;
          if (!inBounds(ex, ey, ez)) continue;
          const cells: number[] = [];
          for (let i = 0; i < WIN_LENGTH; i++) {
            cells.push(cellIndex(x + i * dx, y + i * dy, z + i * dz));
          }
          lines.push(cells);
        }
      }
    }
  }
  return lines;
}

function buildLinesByCell(): (readonly number[])[] {
  const byCell: number[][] = Array.from({ length: BOARD_CELLS }, () => []);
  LINES.forEach((cells, lineIndex) => {
    for (const cell of cells) byCell[cell].push(lineIndex);
  });
  return byCell;
}

/** 指定マスを含むラインのインデックス一覧を返す */
export function linesThroughCell(cell: number): readonly number[] {
  return LINES_BY_CELL[cell];
}
